import $ from "jquery";
import {active} from "./const.js";

// 固定ヘッダーの高さ分ずらす
$(window).on('load', function() {
  const url = $(location).attr('href'),
        headerHeight = $('#js-fixedTop').outerHeight();

  if(url.indexOf("#") != -1){
    const anchor = url.split("#"),
          target = $('#' + anchor[anchor.length - 1]),
          position = Math.floor(target.offset().top) - headerHeight + 5;
		$("html, body").animate({scrollTop:position}, 10);
  }
});
